import * as React from "react";

import "./Switch.scss";

interface Props {
  on: boolean;
  onChange?: (event: any) => void;
  onSet?: (on: boolean, name?: string) => void;
  className?: string;
  name?: string;
  analytics?: any;
  children?: any;
  isInRightCol?: boolean;
  readOnly?: boolean;
  label?: string;
  isDisabled?: boolean;
  readOnlyHoverOverlay?: string;
}

export class Switch extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }
  onClick() {
    if (this.props.onSet) {
      this.props.onSet(!this.props.on, this.props.name);
    }
    if (this.props.onChange) {
      const event = { target: { value: !this.props.on, checked: !this.props.on, type: "checkbox", name: this.props.name } };
      // if (this.props.analytics && this.props.analytics.category) {
      //   if (!this.props.on &&  this.props.analytics.onAction) {    window.AnalyticsEvent(this.props.analytics.category,  this.props.analytics.onAction);
      //   } else if (this.props.on &&  this.props.analytics.offAction) { window.AnalyticsEvent(this.props.analytics.category,  this.props.analytics.offAction); }
      // }

      this.props.onChange(event);
    }
  }
  render() {
    const { readOnlyHoverOverlay, on, readOnly, isDisabled, label } = this.props;
    let className = this.props.className ? this.props.className + " ssSwitch" : "ssSwitch";

    if (on) {
      className += " on";
    }
    if (readOnly) {
      className += " readOnly";
    }
    if (isDisabled) {
      className += " disabled";
    }
    if (!(readOnly || isDisabled)) {
      className += " selectable";
      return (
        <div className="flex flex-row">
          <div className={className} onClick={this.onClick}>
            <div className="indicator"></div>
            <div className="onLabel">ON</div>
            <div className="offLabel">OFF</div>
          </div>
          {label && <div className="switchLabel">{label}</div>}
        </div>
      );
    } else {
      return (
        <div className="flex flex-row">
          <div className={className}>
            <div className="indicator"></div>
            <div className="onLabel">ON</div>
            <div className="offLabel">OFF</div>
            {readOnlyHoverOverlay && <div className="readOnlyHoverOverlay">{readOnlyHoverOverlay}</div>}
          </div>
          {label && <div className="switchLabel readOnlyLabel">{label}</div>}
        </div>
      );
    }
  }

  //   if (this.props.readOnly || this.props.isDisabled) {
  //     const className = (this.props.on) ? "ssSwitch readOnly on": "readOnly ssSwitch";
  //     return <div className={className}>
  //             <div className="readOnlyLabel">{this.props.on ? "ON" : "OFF"}</div>
  //           </div>;
  //   }

  //   const className = (this.props.on) ? "ssSwitch selectable on": "selectable ssSwitch";
  //   if (this.props.label) {
  //     return <div className="flex flex-row">
  //             <div className={className} onClick={this.onClick}>
  //               <div className="indicator"></div>
  //               <div className="onLabel">ON</div>
  //               <div className="offLabel">OFF</div>
  //             </div>
  //             <div className="switchLabel">{this.props.label}</div>
  //     </div>
  //   }

  //   return <div className={className} onClick={this.onClick}>
  //           <div className="indicator"></div>
  //           <div className="onLabel">ON</div>
  //           <div className="offLabel">OFF</div>
  //         </div>;
  //  }
}
